export const silentlyDeleteQueryParams = (queryParams: string[]) => {
  const url = new URL(window.location.href);
  queryParams.forEach((param) => url.searchParams.delete(param));
  window.history.replaceState(null, "", url.toString());
};

export const haveQueryParamsChanged = (payload: {
  currentSearch: string;
  newParams: Record<string, string | null>;
}): boolean => {
  const { currentSearch, newParams } = payload;
  const currentSearchParams = new URLSearchParams(currentSearch);
  const filteredCurrentParams = new URLSearchParams();

  // Only include keys from currentSearch that exist in newParams
  Object.keys(newParams).forEach((key) => {
    if (currentSearchParams.has(key)) {
      filteredCurrentParams.set(key, currentSearchParams.get(key) as string);
    }
  });

  const newSearchParams = new URLSearchParams();
  Object.keys(newParams).forEach((key) => {
    if (newParams[key] !== null && newParams[key] !== undefined) {
      newSearchParams.set(key, newParams[key] as string);
    }
  });

  return newSearchParams.toString() !== filteredCurrentParams.toString();
};

export const replaceIdParamsInRouteWithValue = (payload: {
  route: string;
  idParamsName: string;
  value: string;
}) => {
  const { route, idParamsName, value } = payload;
  return route.replace(idParamsName, value);
};
